import { render, staticRenderFns } from "./OrganisationForm.vue?vue&type=template&id=8a84d4cc&scoped=true&"
import script from "./OrganisationForm.vue?vue&type=script&lang=ts&"
export * from "./OrganisationForm.vue?vue&type=script&lang=ts&"
import style0 from "./OrganisationForm.vue?vue&type=style&index=0&id=8a84d4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a84d4cc",
  null
  
)

export default component.exports